<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title>
        <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">
          <v-icon style="font-size: 20px;">mdi-calendar-badge</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.abamaRequestReservation') }}&nbsp;&nbsp;&nbsp;&nbsp;
        </h5>
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    components: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

